import React from 'react';

import App_data from '../../config/App_data';
import language from '../../../assets/languages/language';

function ReviewSectionButton({ onClick }) {
  return (
    <button className='menu-btn tooltip-hover-questions' onClick={onClick}>
      <img
        width='30px'
        src={App_data.frontend_url + '/img/questions/icon_menu.png'}
        className='my-1'
        alt='questions'
      />
      <div className='tootip_box'>{language.LC().SECTION_REVIEW}</div>
    </button>
  );
}

export default ReviewSectionButton;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ReviewSectionButton.jsx